import React from 'react';
import {Trans} from 'react-i18next';
import AgileFaceText from '../../pages/business/technologies/agileface/RegisteredName';
import AgileHandText from '../../pages/business/technologies/agilehand/component/registeredname/index';

const links = {
  makeup: {
    id: 'c.l.s.leftmenu.online.service.makeup',
    text: (
      <Trans i18nKey="business:c.l.s.leftmenu.online.service.makeup">
        Virtual Makeup Try-On
      </Trans>
    ),
    link: '/business/solutions/online-service/makeup',
    i18nKey: 'business:c.l.s.leftmenu.online.service.makeup',
  },
  eyewear: {
    id: 'c.l.s.leftmenu.online.service.eyewear',
    text: (
      <Trans i18nKey="business:c.l.s.leftmenu.online.service.eyewear">
        Virtual Glasses Try-On
      </Trans>
    ),
    link: '/business/solutions/online-service/eye-wear',
    i18nKey: 'business:c.l.s.leftmenu.online.service.eyewear',
  },
  skincare: {
    id: 'c.l.s.leftmenu.online.service.skincare',
    text: (
      <Trans i18nKey="business:c.l.s.leftmenu.online.service.skincare">
        Skincare Pro
      </Trans>
    ),
    link: '/business/solutions/online-service/skincare-pro',
    i18nKey: 'business:c.l.s.leftmenu.online.service.skincare',
  },
};

export default links;
